// Containers
import Full from '../containers/Full';
import Empty from '../containers/Empty';
import Customers from './views/Customers';
import Dashboard from './views/Dashboard';
import {Roles} from "../admin_area/services/permissionManager";
import CustomerDevices from "./views/CustomerDevices.vue";

// Views
const Customer = () => import('./views/Customer');
const CustomerStore = () => import('./views/CustomerStore');
const CustomerForm = () => import("./views/CustomerForm");
const CustomerStoreForm = () => import("./views/CustomerStoreForm");
const CustomerPos = () => import("./views/CustomerPos.vue");
const DemoAccount = () => import('./views/DemoAccount');
const Devices = () => import('./views/Devices');
const Device = () => import('./views/Device');
const AddDevice = () => import('./views/AddDevice');
const Updates = () => import('./views/Updates');
const PurchaseUpdates = () => import('./views/PurchaseUpdates');
const Orders = () => import('./views/Orders');
const Order = () => import('./views/Order');
const OrderRequests = () => import('./views/OrderRequests');
const OrderRequest = () => import('./views/OrderRequest');
const DgfeInitializations = () => import('./views/DgfeInitializations');
const DgfeInitialization = () => import('./views/DgfeInitialization');
const Settings = () => import('./views/Settings');
const DistributorOrders = () => import('./views/DistributorOrders');
const DistributorAccounts = () => import('./views/DistributorAccounts');
const DistributorAccount = () => import('./views/DistributorAccount');
const AddDemoCustomer = () => import('./views/AddDemoCustomer');
const Gcs = () => import('./views/Gcs');
const Msg = () => import('./views/Msg.vue');
const Company = () => import('./views/Company');
const Prog = () => import('./components/Prog');
const Rental = () => import('./views/Rental');
const OnDemandSettings = () => import('./views/OnDemandSettings');
const OnDemandMassiveList = () => import('./views/OnDemandMassiveList');
const Scheduled = () => import('./views/Scheduled');
const Labels = () => import('./views/Labels');
const PosSettings  = () => import('./views/pos_settings/PosSettings');
const PaymentSettings  = () => import('./views/pos_settings/PaymentSettings');;
const PaymentSettingsDetail  = () => import('./views/pos_settings/PaymentSettingsDetail');
const VatSettings  = () => import('./views/pos_settings/VatSettings');
const VirtualPrintersSettings  = () => import('./views/pos_settings/VirtualPrintersSettings');
const OperatorSettings  = () => import('./views/pos_settings/OperatorSettings');
const OperatorSettingsDetail  = () => import('./views/pos_settings/OperatorSettingsDetail');
const StockforshopLicense = () => import('./views/StockforshopLicense.vue');
const Users = () => import('./views/Users');
const User = () => import('./views/User');
const Registration = () => import('./views/Registration');
const Appalto = () => import('./views/Appalto');


const routes = (lang, home) => [
  {
    path: `/${lang}/dealer`,
    name: 'Home',
    meta: { label: 'Home', icon: null },
    redirect: { name: `${home}` },
    component: Full,
    children: [
        {
          path: 'registration',
          name: 'Registration',
          meta: {
            label: 'Dealer Registration',
            previous: 'Home',
            icon: null,
            hiddenFor: ['has_distributor', 'distributor']
          },
          component: Registration
        },
        {
            path: 'gcs',
            name: 'Gcs',
            meta: {
                label: 'General Conditions of Sale',
                previous: 'Home',
                icon: null,
                hiddenFor: ['gcs_confirmed']
            },
            component: Gcs
        },
        {
            path: 'msg',
            name: 'Msg',
            meta: {
                label: 'Message',
                previous: 'Home',
                icon: null,
                hiddenFor: ['active_account']
            },
            props: true,
            component: Msg
        },
        // {
        //     path: 'garcon',
        //     name: 'Garcon',
        //     meta: { label: 'Garcon', previous: 'Home', icon: null },
        //     component: Garcon
        // },
        // {
        //     path: 'waiter',
        //     name: 'Waiter',
        //     meta: { label: 'Waiter', previous: 'Home', icon: null },
        //     component: Garcon
        // },
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: {
            label: 'Dashboard',
            previous: 'Home',
            icon: null,
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
          },
          component: Dashboard
        },
        {
            path: 'customers',
            name: 'Customers',
            meta: {
                label: 'Customers',
                previous: 'Home',
                icon: null,
                hiddenFor: ['gcs_unchecked','no_active_account']
            },
            component: Customers
        },
        {
            path: 'customer/new',
            name: 'Create Customer',
            component: CustomerForm,
            meta: {
                label: 'Create Customer',
                previous: 'Customers',
                icon: null,
                hiddenFor: ['gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'customer/demo',
            name: 'AccountDemoContainer',
            redirect: { name: 'Account demo' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Account demo',
                    component: DemoAccount,
                    meta: {
                        label: 'Account demo XStore',
                        previous: 'Home',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'not_has_demo']
                    },
                },
                {
                    path: 'new',
                    name: 'AddDemoCustomer',
                    meta: {
                        label: 'Add XStore demo account',
                        icon: null,
                        previous: 'Customers',
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['gcs_unchecked','no_active_account', 'has_demo']
                    },
                    component: AddDemoCustomer
                },
                {
                    path: ':customer_id/pos-settings',
                    name: 'PosSettingsContainer',
                    redirect: { name: 'Pos Settings Demo' },
                    meta: {
                        label: 'Pos settings',
                        icon: null
                    },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Pos Settings Demo',
                            meta: { previous: 'Account demo', label: 'Pos settings', icon: null},
                            props: {
                                demo: true
                            },
                            component: PosSettings,
                        },
                        {
                            path: 'payments',
                            name: 'Payment Settings Demo',
                            meta: { label: 'Payment settings', icon: null, previous: 'Pos Settings Demo'},
                            props: {
                                demo: true
                            },
                            component: PaymentSettings
                        },
                        {
                            path: 'payments/:payment_id?',
                            name: 'Payment Settings Details Demo',
                            meta: { label: 'Payment details', icon: null, previous: 'Payment Settings Demo'},
                            props: true,
                            component: PaymentSettingsDetail
                        },
                        {
                            path: 'vats',
                            name: 'Vat Settings Demo',
                            meta: { label: 'VAT Groups settings', icon: null, previous: 'Pos Settings Demo'},
                            props: true,
                            component: VatSettings
                        },
                        {
                            path: 'operators',
                            name: 'Operator Settings Demo',
                            meta: { label: 'Operators', icon: null, previous: 'Pos Settings Demo'},
                            props: {
                                demo: true
                            },
                            component: OperatorSettings
                        },
                        {
                            path: 'operators/:operator_id?',
                            name: 'Operator Settings Details Demo',
                            meta: { label: 'Operator settings details', icon: null, previous: 'Operator Settings Demo'},
                            props: {
                                demo: true
                            },
                            component: OperatorSettingsDetail
                        },
                        {
                            path: 'printers',
                            name: 'Printers Settings Demo',
                            meta: { label: 'Printers', icon: null, previous: 'Pos Settings Demo', disabledForLicenseCode: ['personal', 'premium']  },
                            props: true,
                            component: VirtualPrintersSettings
                        },
                    ]
                }
            ]
        },
        {
            path: 'customer/:customer_id',
            name: 'Customer',
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Customer',
                    component: Customer,
                    meta: {
                        label: 'Customer',
                        icon: null,
                        previous: 'Customers',
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    },
                },
                {
                  path: 'devices',
                  name: 'Customer devices',
                  meta: {
                    label: 'Customer devices',
                    icon: null,
                    previous: 'Customer',
                    hiddenFor: ['gcs_unchecked','no_active_account']
                  },
                  component: CustomerDevices
                },
                {
                    path: 'store/:store_id',
                    name: 'Customer Store',
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Customer Store',
                            component: CustomerStore,
                            meta: {
                                label: 'Store',
                                previous: 'Customer',
                                icon: null,
                                hiddenFor: ['gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'edit',
                            name: 'Edit Store',
                            component: CustomerStoreForm,
                            meta: {
                                label: 'Edit Store',
                                previous: 'Customer Store',
                                icon: null,
                                hiddenFor: ['gcs_unchecked','no_active_account']
                            }
                        },
                        {
                            path: 'pos/:pos_id',
                            name: 'Customer Pos',
                            component: CustomerPos,
                            meta: {
                                label: 'POS',
                                previous: 'Customer Store',
                                icon: null,
                                hiddenFor: ['gcs_unchecked','no_active_account']
                            }
                        },
                    ]
                },
                {
                    path: 'store/new',
                    name: 'Add Store',
                    component: CustomerStoreForm,
                    meta: {
                        label: 'Add Store',
                        previous: 'Customer',
                        icon: null,
                        hiddenFor: ['gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: 'pos-settings',
                    name: 'Pos Settings Container',
                    meta: {
                        label: 'Pos settings',
                        icon: null
                    },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Pos Settings',
                            meta: { previous: 'Customer', label: 'Pos settings', icon: null},
                            component: PosSettings,
                        },
                        {
                            path: 'payments',
                            name: 'Payment Settings',
                            meta: { label: 'Payment settings', icon: null, previous: 'Pos Settings'},
                            props: true,
                            component: PaymentSettings
                        },
                        {
                            path: 'payments/:payment_id?',
                            name: 'Payment Settings Details',
                            meta: { label: 'Payment details', icon: null, previous: 'Payment Settings'},
                            props: true,
                            component: PaymentSettingsDetail
                        },
                        {
                            path: 'vats',
                            name: 'Vat Settings',
                            meta: { label: 'VAT Groups settings', icon: null, previous: 'Pos Settings'},
                            props: true,
                            component: VatSettings
                        },
                        {
                            path: 'operators',
                            name: 'Operator Settings',
                            meta: { label: 'Operators', icon: null, previous: 'Pos Settings'},
                            props: true,
                            component: OperatorSettings
                        },
                        {
                            path: 'operators/:operator_id?',
                            name: 'Operator Settings Details',
                            meta: { label: 'Operator settings details', icon: null, previous: 'Operator Settings'},
                            props: true,
                            component: OperatorSettingsDetail
                        },
                        {
                            path: 'printers',
                            name: 'Printers Settings',
                            meta: { label: 'Printers', icon: null, previous: 'Pos Settings', disabledForLicenseCode: ['personal', 'premium']  },
                            props: true,
                            component: VirtualPrintersSettings
                        },
                    ]
                }
            ]
        },
        {
            path: 'dgfe-initializations',
            name: 'DGFE Initializations',
            component: DgfeInitializations,
            meta: {
                label: 'DGFE Management',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'dgfe-initialization/add',
            name: 'DGFE Initialization',
            component: DgfeInitialization,
            meta: {
                label: 'DGFE Detail',
                previous: 'DGFE Initializations',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
      {
        path: 'users',
        name: 'UsersContainer',
        meta: { label: 'Users', previous: 'Home', icon: null },
        redirect: { name: 'Users' },
        component: Empty,
        children: [
          {
            path: '',
            name: 'Users',
            component: Users,
            meta: {
              label: 'Users',
              previous: 'Home',
              icon: null,
            },
            props: false
          },
          {
            path: ':user_id?',
            name: 'UserContainer',
            meta: { label: 'Detail', icon: null },
            redirect: { name: 'User' },
            component: Empty,
            children: [
              {
                path: '',
                name: 'User',
                component: User,
                meta: {
                  label: 'User',
                  previous: 'Users',
                  icon: null,
                },
                props: false
              },
            ]
          },

        ]
      },
        {
            path: 'company',
            name: 'CompanyContainer',
            meta: {
                label: 'Company Data',
                previous: 'Home',
                icon: null
            },
          redirect: { name: 'Company' },
          component: Empty,
          children: [
            {
              path: '',
              name: 'Company',
              component: Company,
              meta: {
                label: 'Company',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
              }
            },
              {
                path: 'appalto',
                name: 'Firma Appalto',
                component: Appalto,
                meta: {
                  label: 'Firma Appalto',
                  previous: 'Company',
                  icon: null,
                  allowedFor: ['mkt_it'],
                  hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                }
              },
            ]
        },
        {
            path: 'devices',
            name: 'DevicesContainer',
            meta: {
                label: 'Manage devices',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            },
            redirect: { name: 'Manage devices' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Manage devices',
                    component: Devices,
                    meta: {
                        label: 'Manage devices',
                        previous: 'Home',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: 'add',
                    name: 'Add Device',
                    component: AddDevice,
                    meta: {
                        label: 'Add device',
                        previous: 'Manage devices',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: ':device_id',
                    name: 'Device detail',
                    component: Device,
                    meta: {
                        label: 'Device detail',
                        previous: 'Manage devices',
                        icon: null,
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account']
                    }
                },
                {
                    path: ':device_id/rental',
                    name: 'Operating rental',
                    component: Rental,
                    meta: {
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
                        previous: 'Device detail',
                        icon: null,
                        label: 'Operating rental'
                    }
                },
                {
                    path: ':device_id/ondemand',
                    name: 'On demand settings',
                    component: OnDemandSettings,
                    meta: {
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
                        previous: 'Device detail',
                        icon: null,
                        label: 'On Demand update settings'
                    }
                },
                {
                    path: ':device_id/prog/:prog_id',
                    name: 'Prog',
                    component: Prog,
                    meta: {
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
                        previous: 'Device detail',
                        icon: null,
                        label: 'Programmazioni'
                    }
                }
            ]
        },
        {
            path: 'ondemand-massive',
            name: 'Massive on demand settings',
            component: OnDemandMassiveList,
            meta: {
                label: 'On Demand updates',
                previous: 'Manage devices',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'updates',
            name: 'Update history',
            component: Updates,
            meta: {
                label: 'Update history',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'scheduled',
            name: 'Scheduled updates',
            component: Scheduled,
            meta: {
                label: 'Scheduled updates',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'purchase-updates',
            name: 'Purchase updates',
            component: PurchaseUpdates,
            meta: {
                label: 'Purchase updates',
                previous: 'Manage devices',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'orders',
            name: 'Orders',
            component: Orders,
            meta: {
                label: 'Orders',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'orders/:order_id',
            name: 'Order',
            component: Order,
            meta: {
                label: 'Order',
                previous: 'Orders',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'order-requests',
            name: 'Order Requests',
            component: OrderRequests,
            meta: {
                label: 'Order Requests',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'no_prepayment']
            }
        },
        {
            path: 'order-requests/:order_request_id',
            name: 'Order Request',
            component: OrderRequest,
            meta: {
                label: 'Order Request',
                previous: 'Order Requests',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'no_prepayment']
            }
        },
        {
            path: 'labels-management',
            name: 'Labels management',
            component: Labels,
            meta: {
                label: 'Labels management',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'settings',
            name: 'Settings',
            component: Settings,
            meta: {
                label: 'Settings',
                previous: 'Home',
                icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-orders',
            name: 'Distributor Orders',
            component: DistributorOrders,
            meta: {
                label: 'Order history',
                previous: 'Home',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-orders/:order_id',
            name: 'Distributor Order',
            component: Order,
            meta: {
                label: 'Order',
                previous: 'Distributor Orders',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-accounts',
            name: 'Distributor Accounts',
            component: DistributorAccounts,
            meta: {
                label: 'Account',
                previous: 'Home',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            path: 'distributor-accounts/:invitation_id',
            name: 'Distributor Account',
            component: DistributorAccount,
            meta: {
                label: 'Account',
                previous: 'Distributor Accounts',
                icon: null,
                allowedFor: ['distributor', 'mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account']
            }
        },
        {
            // will match everything
            path: '*',
            redirect: { name: 'Dashboard' },
        },
    ]
}
];

export default routes;
